import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { typography } from '../../../../styles/typography';
import { MediaQueries } from '../../../../styles/Grid';

export const container = css(typography.effra22, {
  display: 'flex',
  position: 'relative',
  marginBottom: 16,
  [MediaQueries.lgAndUp]: {
    marginBottom: 0,
  },
});

export const input = css({
  position: 'absolute',
  opacity: 0,

  [`&:focus ~ .checkbox-button-decoration`]: {
    outline: `2px solid ${colorsPalette.teal}`,
  },
});

export const checkboxDecoration = css({
  position: 'absolute',
  top: 16,
  right: 16,
  borderRadius: 2,
  width: 28,
  height: 28,
  border: `1px solid ${colorsPalette.grey20}`,
  textAlign: 'center',
  lineHeight: 1,
  transition: `border-color 0.3s, background-color 0.3s`,
  pointerEvents: 'none',
});

export const checkboxDecorationChecked = css({
  borderColor: colorsPalette.teal,
  backgroundColor: colorsPalette.teal,
});

export const checkboxIcon = css({
  color: colorsPalette.transparent,
  fontSize: 11,
});

export const checkboxIconChecked = css({
  color: colorsPalette.white,
});

export const label = css({
  display: 'block',
  width: '100%',
  borderRadius: 2,
  border: `1px solid ${colorsPalette.grey20}`,
  cursor: 'pointer',
  padding: `16px 60px 16px 16px`,
  transition: 'background-color 0.3s',
  [MediaQueries.lgAndUp]: {
    padding: `16px 60px 16px 16px`,
  },

  ':hover': {
    backgroundColor: colorsPalette.grey10,
    borderColor: colorsPalette.grey10,
  },
});

export const labelChecked = css({
  '&, &:hover': {
    backgroundColor: colorsPalette.white,
    borderColor: colorsPalette.white,
    boxShadow: '0 10px 80px rgba(0, 0, 0, 0.08)',
  },
});
